import React, { useMemo, useContext } from "react";
import {
  isEmpty,
  addZero,
  timeFormat,
  getDwk,
  isToday,
  getTimeText,
  recoverTag,
} from "bodycodi/cmap/app/js/common";
import { useSelector } from "react-redux";
import { RootState } from "bodycodi/cmap/app/redux/store";
import { StateContext } from "bodycodi/cmap/app/components/common/context";
import icon_next from "bodycodi/cmap/app/svg/icon_next.svg";

type AddScheduleStepProp = {
  center: any;
  open: boolean;
  setOpen: Function;
  step: any;
  setStep: Function;
  scheduleType: string;
  clickNextStep: any;
  clickPrevStep: any;
  pass: any;
  chooseDate: any;
  time: any;
  member: any;
  startTime: any;
  endTime: any;
  scheduleTitle: string;
  holidayList: any;
  isAvailableTime?: boolean;
};

const AddScheduleStep = ({
  center,
  open,
  setOpen,
  step,
  scheduleType,
  clickNextStep,
  clickPrevStep,
  pass,
  chooseDate,
  time,
  member,
  startTime,
  endTime,
  scheduleTitle,
  holidayList,
  isAvailableTime,
}: AddScheduleStepProp) => {
  const { partnerName, partnerBranchName } = useSelector((state: RootState) => state.partner);
  const { state } = useContext(StateContext);
  const holiday = holidayList[chooseDate?.date];
  const holidayDesc: { [key: string]: string } = {
    COACH_OFF: "오늘 강사님 휴일이에요. 다른 날짜를 선택해주세요!",
    PARTNER_OFF: "오늘 강사님 휴일이에요. 다른 날짜를 선택해주세요!",
    PASS_PAUSE: "이용권이 중지된 상태에요. 다른 날짜를 선택해주세요!",
  };
  const passName =
    pass.serviceName +
    " " +
    pass.usePeriod +
    "" +
    (pass.usePeriodType === "M" ? "개월" : "일") +
    " " +
    (isEmpty(pass.useNumber) ? "" : pass.useNumber * 1 > 0 ? pass.useNumber + "회" : "");
  const from = timeFormat(time.reservationStartTime);
  const to = timeFormat(time.reservationEndTime);
  const timeTextAppointment = " " + from.ampm + " " + from.time + " - " + to.ampm + " " + to.time;
  const timeTextEtc = `${getTimeText(startTime)} - ${getTimeText(endTime)}`;

  const isValidTime = useMemo(() => {
    if (!isAvailableTime) {
      return false;
    }
    if (!scheduleTitle) {
      return false;
    }
    if (startTime.hour === endTime.hour && startTime.min === endTime.min) {
      return false;
    }
    return true;
  }, [isAvailableTime, scheduleTitle, startTime, endTime]);

  if (!state.isShowBottom) {
    return <></>;
  }

  return (
    <div className="add-schedule-center-confirm">
      {scheduleType === "APPOINTMENT" && (
        <div className="step-top">
          <div className="condition">
            {partnerName} {partnerBranchName}
          </div>
          {!isEmpty(pass) && (
            <div className="condition">
              {member.name} -{" "}
              <span className="gray">
                {recoverTag(passName)} <span className="slash">|</span> {pass.serviceTime}분
              </span>
            </div>
          )}
          {!isEmpty(chooseDate) && (
            <>
              <div className="condition">
                {chooseDate.month}. {addZero(chooseDate.date)}.{" "}
                {getDwk(new Date(chooseDate.year, chooseDate.month - 1, chooseDate.date).getDay())}{" "}
                {isToday(chooseDate) ? <span> &#183; 오늘</span> : ""}{" "}
                {!isEmpty(time) && <> &#183; {timeTextAppointment}</>}
                {holiday && (
                  <div className="holiday">
                    <span>{holidayDesc[holiday]}</span>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      )}
      {scheduleType === "CS" && (
        <div className="step-top">
          <div className="condition">
            {partnerName} {partnerBranchName}
          </div>
          {!isEmpty(member.name) && <div className="condition">{member.name} - 상담 스케줄</div>}
          {!isEmpty(chooseDate) && (
            <>
              <div className="condition">
                {chooseDate.month}. {addZero(chooseDate.date)}.{" "}
                {getDwk(new Date(chooseDate.year, chooseDate.month - 1, chooseDate.date).getDay())}{" "}
                {isToday(chooseDate) ? <span> &#183; 오늘</span> : ""}{" "}
                {!isEmpty(startTime) && !isEmpty(endTime) && <> &#183; {timeTextEtc}</>}
                {holiday && (
                  <div className="holiday">
                    <span>{holidayDesc[holiday]}</span>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      )}
      {scheduleType === "OT" && (
        <div className="step-top">
          <div className="condition">
            {partnerName} {partnerBranchName}
          </div>
          {!isEmpty(member.name) && <div className="condition">{member.name} - OT 스케줄</div>}
          {!isEmpty(chooseDate) && (
            <>
              <div className="condition">
                {chooseDate.month}. {addZero(chooseDate.date)}.{" "}
                {getDwk(new Date(chooseDate.year, chooseDate.month - 1, chooseDate.date).getDay())}{" "}
                {isToday(chooseDate) ? <span> &#183; 오늘</span> : ""}{" "}
                {!isEmpty(startTime) && !isEmpty(endTime) && <> &#183; {timeTextEtc}</>}
                {holiday && (
                  <div className="holiday">
                    <span>{holidayDesc[holiday]}</span>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      )}
      {scheduleType === "ET" && (
        <div className="step-top">
          <div className="condition">
            {partnerName} {partnerBranchName}
          </div>
          {!isEmpty(chooseDate) && (
            <>
              <div className="condition">
                {chooseDate.month}. {addZero(chooseDate.date)}.{" "}
                {getDwk(new Date(chooseDate.year, chooseDate.month - 1, chooseDate.date).getDay())}{" "}
                {isToday(chooseDate) ? <span> &#183; 오늘</span> : ""}{" "}
                {!isEmpty(startTime) && !isEmpty(endTime) && <> &#183; {timeTextEtc}</>}
                {holiday && (
                  <div className="holiday">
                    <span>{holidayDesc[holiday]}</span>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      )}
      <div className="btn-group">
        <div className="btn left white" onClick={clickPrevStep}>
          이전
        </div>
        {scheduleType === "APPOINTMENT" && (
          <>
            {step === 2 && (
              <div
                className={"btn right" + (!isEmpty(pass) ? " blue" : " gray")}
                {...(!isEmpty(pass) && { onClick: clickNextStep })}
              >
                날짜 선택
                <img src={icon_next} />
              </div>
            )}
            {step === 3 && holiday && (
              <div className={"btn right gray"}>
                시간 선택
                <img src={icon_next} />
              </div>
            )}
            {step === 3 && !holiday && (
              <div
                className={"btn right" + (!isEmpty(chooseDate) ? " blue" : " gray")}
                {...(!isEmpty(chooseDate) && { onClick: clickNextStep })}
              >
                시간 선택
                <img src={icon_next} />
              </div>
            )}
            {step === 4 && (
              <div
                className={"btn right" + (!isEmpty(time) ? " blue" : " gray")}
                {...(!isEmpty(time) && { onClick: clickNextStep })}
              >
                예약하기
              </div>
            )}
          </>
        )}
        {scheduleType === "CS" && (
          <>
            {step === 2 && (
              <div
                className={"btn right" + (!isEmpty(member.name) ? " blue" : " gray")}
                {...(!isEmpty(member.name) && { onClick: clickNextStep })}
              >
                날짜 선택
                <img src={icon_next} />
              </div>
            )}
            {step === 3 && holiday && (
              <div className={"btn right gray"}>
                시간ㆍ내용 입력
                <img src={icon_next} />
              </div>
            )}
            {step === 3 && !holiday && (
              <div
                className={"btn right" + (!isEmpty(chooseDate) ? " blue" : " gray")}
                {...(!isEmpty(chooseDate) && { onClick: clickNextStep })}
              >
                시간ㆍ내용 입력
                <img src={icon_next} />
              </div>
            )}
            {step === 4 && (
              <div
                className={"btn right" + (isValidTime ? " blue" : " gray")}
                {...(isValidTime && { onClick: clickNextStep })}
              >
                예약하기
              </div>
            )}
          </>
        )}
        {scheduleType === "OT" && (
          <>
            {step === 2 && (
              <div
                className={"btn right" + (!isEmpty(member.name) ? " blue" : " gray")}
                {...(!isEmpty(member.name) && { onClick: clickNextStep })}
              >
                날짜 선택
                <img src={icon_next} />
              </div>
            )}
            {step === 3 && holiday && (
              <div className={"btn right gray"}>
                시간ㆍ내용 입력
                <img src={icon_next} />
              </div>
            )}
            {step === 3 && !holiday && (
              <div
                className={"btn right" + (!isEmpty(chooseDate) ? " blue" : " gray")}
                {...(!isEmpty(chooseDate) && { onClick: clickNextStep })}
              >
                시간ㆍ내용 입력
                <img src={icon_next} />
              </div>
            )}
            {step === 4 && (
              <div
                className={"btn right" + (isValidTime ? " blue" : " gray")}
                {...(isValidTime && { onClick: clickNextStep })}
              >
                예약하기
              </div>
            )}
          </>
        )}
        {scheduleType === "ET" && (
          <>
            {step === 2 && holiday && (
              <div className={"btn right gray"}>
                시간ㆍ내용 입력
                <img src={icon_next} />
              </div>
            )}
            {step === 2 && !holiday && (
              <div
                className={"btn right" + (!isEmpty(chooseDate) ? " blue" : " gray")}
                {...(!isEmpty(chooseDate) && { onClick: clickNextStep })}
              >
                시간ㆍ내용 입력
                <img src={icon_next} />
              </div>
            )}
            {step === 3 && (
              <div
                className={"btn right" + (isValidTime ? " blue" : " gray")}
                {...(isValidTime && { onClick: clickNextStep })}
              >
                추가하기
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AddScheduleStep;
